// shared/pipes/locale-currency.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyService } from '../services/currency.service';

// shared/pipes/locale-currency.pipe.ts
@Pipe({ name: 'currencySymbol', pure: true })
export class CurrencySymbolPipe implements PipeTransform {
  constructor(private currency: CurrencyService) {}

  transform(_value: unknown, mode: 'symbol' | 'code' = 'symbol'): string {
    const locale = this.currency.locale;   
    const code   = this.currency.code;   

    const token = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: code,
        currencyDisplay: mode,          
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
      .formatToParts(0)
      .find(p => p.type === 'currency')!.value
      .replace(/\u00A0|\u202F/g, '');      

    return token;
  }
}

